import React, { useState } from 'react';
import { useBts } from '@/context/btsContext/BtsContextProvider';
import ProposalSchoolForm from './ProposalSchoolForm';
import ProposalProduct from './ProposalProduct';
import ProgressBarTabs from './ProgressBarTabs';
import { ModalProvider } from '../../components/common/modal/ModalContext';

const steps = ['School Section', 'Products'];

const ProposalSchool = () => {
  const { btsSchool, setBtsSchool } = useBts();
  const [activeStep, setActiveStep] = useState(1);
  const formRef = React.useRef();

  // Navigation handler for next section
  const goToNextSection = () => {
    setActiveStep(2);
  };

  // Handle step click from ProgressBarTabs
  const handleStepClick = (stepIdx) => {
    // If moving from school to product, submit the form
    if (activeStep === 1 && stepIdx === 1 && formRef.current) {
      formRef.current.dispatchEvent(
        new Event('submit', { cancelable: true, bubbles: true }),
      );
    } else {
      setActiveStep(stepIdx + 1);
    }
  };

  // Get proposalId from btsSchool.proposal.id if available
  const proposalId = btsSchool?.proposal?.id;

  return (
    <div className="">
      <div className="font-500 text-xl lg:text-2xl px-5 py-2 bg-gray-200">
        {activeStep === 1 ? 'School Information' : 'Products'}
      </div>
      {activeStep === 1 && (
        <ProposalSchoolForm
          ref={formRef}
          btsSchool={btsSchool}
          setBtsSchool={setBtsSchool}
          goToNextSection={goToNextSection}
          proposalId={proposalId}
        />
      )}
      {activeStep === 2 && (
        <ModalProvider>
          <ProposalProduct
            proposalId={proposalId}
            goToNextSection={goToNextSection}
          />
        </ModalProvider>
      )}
      <ProgressBarTabs
        steps={steps}
        activeStep={activeStep}
        onStepClick={handleStepClick}
      />
    </div>
  );
};

export default ProposalSchool;

// Render ProposalProduct separately, outside the ProposalSchool container
// (e.g., in your AppRoutes or parent component, as you already do with /bts/proposal-product/:id)

// Render ProposalProduct separately, outside the ProposalSchool container
// (e.g., in your AppRoutes or parent component, as you already do with /bts/proposal-product/:id)
